import {axiosRequest} from '../../configs/axios.config';

export class SelectionProcessStatusService {
  getAllWithParams(tenantId, success, error) {
    const url = !!!tenantId
      ? `/selection_process_statuses`
      : `/tenants/${tenantId}/selection_process_statuses`;

    axiosRequest.get(url)
    .then(({data}) => success(data))
    .catch(errorResp => error(errorResp))
  }

  getAll(success, error) {
    axiosRequest.get('selection_process_statuses')
    .then(({data}) => success(data))
    .catch(errorResp => error(errorResp))
  }
}